import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Notification, NotificationType } from '../../store';
import { Store } from '@ngrx/store';
import moment from 'moment';
import * as fromNotifications from '../../store';
import { UserContextService } from 'src/app/modules/core/services/user-context.service';
import { NotificationService } from '../../store/notification.service';
import { DistanceService } from 'src/app/modules/core/services/distance/distance.service';
import { DataFormattingService } from 'src/app/modules/cop/services/format/data-formatting.service';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_APP_CULTURE_CODE } from 'src/app/modules/core/languages/language.model';
import { CultureService } from 'src/app/modules/core/services/culture.service';

@Component({
  selector: 'topo-notification-hover',
  templateUrl: './notification-hover.component.html',
  styleUrls: ['./notification-hover.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationHoverComponent implements OnInit {
  NotificationType = NotificationType;

  visible: boolean = true;
  fromIcon: string;
  fromName: string;
  name: string;
  distance: string;
  message: string;
  subject: string;
  location: string;
  recipientName: string;
  dateSentFormatted: string;
  dateSentElapsedTime: string;
  uId: string;
  markRead: boolean = false;
  defaultCultureCode = DEFAULT_APP_CULTURE_CODE;
  isTransient: boolean;
  soundUrl: string;
  showDefaultIcon: boolean = false;
  messageType: NotificationType;
  escalatedMessage: string;

  @Input()
  set notification(value: Notification) {
    const cultureCode = this.cultureService.currentLang;
    const translation =
      value.translations.find(t => t.cultureCode === cultureCode) ??
      value.translations.find(t => t.cultureCode === this.defaultCultureCode) ??
      value.translations[0];

    this.uId = value.uId;
    this.fromIcon = value.fromIcon;
    this.fromName = value.fromName;
    this.distance = !isNaN(value.distance) && value.distance >= 0 ? this.distanceService.parseToFriendlyDistance(value.distance) : null;
    this.message = translation.message;
    this.subject = translation.subject;
    this.location = translation.location;
    if (!this.location && value.geometry) {
      this.location = this.dataFormattingService.getLatLngForDisplay(value.geometry);
    }
    this.dateSentFormatted = this.cultureService.getDateDisplay(moment(value.dateSent), 'LONG-DATE-WITH-TIME');
    this.dateSentElapsedTime = moment(value.dateSent).from(new Date());
    this.isTransient = value.isTransient;
    this.soundUrl = value.soundUrl;
    this.messageType = value.messageType;

    this.name = null;
    this.recipientName = null;
    this.escalatedMessage = null;

    if (this.messageType == NotificationType.MassCommunication && !!this.fromName) {
      try {
        const fromData = JSON.parse(this.fromName);
        this.name = fromData.name;
        this.recipientName = fromData.recipientName;
      } catch (e) {}

      this.escalatedMessage = this.getEscalatedMessage();
    }
  }

  @Input()
  index: number;

  constructor(
    private store$: Store,
    private changeDetector: ChangeDetectorRef,
    private notificationService: NotificationService,
    private distanceService: DistanceService,
    private cultureService: CultureService,
    private dataFormattingService: DataFormattingService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (!!this.soundUrl) {
      this.notificationService.playNotificationSound(this.soundUrl);
    }

    setTimeout(() => {
      this.visible = false;
      const markRead = this.markRead && !this.isTransient;
      this.store$.dispatch(fromNotifications.dismissHoverNotification({ uId: this.uId, markRead }));
      this.changeDetector.detectChanges();
    }, 4000);
  }

  hide(): void {
    this.markRead = true;
    this.visible = false;
    this.changeDetector.detectChanges();
  }

  iconLoad(e): void {
    if (e.type == 'error') {
      this.showDefaultIcon = true;
      this.changeDetector.detectChanges();
    }
  }

  private getEscalatedMessage(): string {
    return this.translateService.instant('NOTIFICATIONS.ESCALATED-MESSAGE', {
      name: this.name,
      channel: this.location,
      response: this.subject
    });
  }
}
